import React, { useState } from 'react';
import EmailCard from './EmailCard';
import './EmailList.css';

function EmailList({ emails, loading, onRefresh }) {
  const [expandedId, setExpandedId] = useState(null);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading emails...</p>
      </div>
    );
  }

  if (emails.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📭</div>
        <h3>No emails yet</h3>
        <p>Your inbox will appear here. The system scans every 10 minutes.</p>
        <button onClick={onRefresh} className="refresh-btn">
          🔄 Refresh Now
        </button>
      </div>
    );
  }

  const importanceGroups = {
    critical: emails.filter(e => e.importance >= 4),
    high: emails.filter(e => e.importance === 3),
    medium: emails.filter(e => e.importance === 2),
    low: emails.filter(e => e.importance <= 1)
  };

  return (
    <div className="email-list">
      {importanceGroups.critical.length > 0 && (
        <div className="importance-group">
          <h3 className="group-title">⭐⭐⭐⭐⭐ Critical (Highest Priority)</h3>
          <div className="group-content">
            {importanceGroups.critical.map(email => (
              <EmailCard
                key={email._id}
                email={email}
                isExpanded={expandedId === email._id}
                onToggle={() => setExpandedId(expandedId === email._id ? null : email._id)}
              />
            ))}
          </div>
        </div>
      )}

      {importanceGroups.high.length > 0 && (
        <div className="importance-group">
          <h3 className="group-title">⭐⭐⭐ High Priority</h3>
          <div className="group-content">
            {importanceGroups.high.map(email => (
              <EmailCard
                key={email._id}
                email={email}
                isExpanded={expandedId === email._id}
                onToggle={() => setExpandedId(expandedId === email._id ? null : email._id)}
              />
            ))}
          </div>
        </div>
      )}

      {importanceGroups.medium.length > 0 && (
        <div className="importance-group">
          <h3 className="group-title">⭐⭐ Medium Priority</h3>
          <div className="group-content">
            {importanceGroups.medium.map(email => (
              <EmailCard
                key={email._id}
                email={email}
                isExpanded={expandedId === email._id}
                onToggle={() => setExpandedId(expandedId === email._id ? null : email._id)}
              />
            ))}
          </div>
        </div>
      )}

      {importanceGroups.low.length > 0 && (
        <div className="importance-group">
          <h3 className="group-title">⭐ Low Priority</h3>
          <div className="group-content">
            {importanceGroups.low.map(email => (
              <EmailCard
                key={email._id}
                email={email}
                isExpanded={expandedId === email._id}
                onToggle={() => setExpandedId(expandedId === email._id ? null : email._id)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default EmailList;
